/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TerminalActionType = {
    QR_CODE: 'QR_CODE',
    PING: 'PING',
    SAVE_CARD: 'SAVE_CARD',
    SIGNATURE: 'SIGNATURE',
    CONFIRMATION: 'CONFIRMATION',
    RECEIPT: 'RECEIPT',
    DATA_COLLECTION: 'DATA_COLLECTION',
    SELECT: 'SELECT'
} as const;
export type TerminalActionType = typeof TerminalActionType[keyof typeof TerminalActionType];

